//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { useEffect, useState } from "react";
import { defaultValue } from "../SubjectSelector/hook";
import isEqual from "lodash.isequal";
import { useMedia } from "../../../../components/ui-elements/SizeDetector";

export const useSubjectPicker = (
  valueProp = [],
  options = [],
  placeholder = "Select Subjects",
  path?: string
) => {
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useMedia("(max-width: 420px)");
  const [value, setValue] = useState(valueProp);

  const getLabelByValues = (values) => {
    return values.map((value) =>
      options.find((option) => option.value === value)
    );
  };

  // useEffect(() => {
  //   setValue(valueProp);
  // }, [valueProp]);

  const handleChange = (values) => {
    // let newValues = getLabelByValues(values);
    setValue(() => values);
    // setOutput(newValues);
  };

  const renderText = () => {
    if (valueProp && valueProp.length > 0) {
      let newValues = options ? getLabelByValues(valueProp) : [];

      if (newValues[0] !== undefined && !isEqual(valueProp, defaultValue)) {
        let finalString = newValues
          .map((item) => {
            if (!item) {
            }
            return item.label;
          })
          .toString()
          .split(",")
          .join(", ");

        // Approximately 33 character is what will fit in Mobile
        if (finalString.length > 33) {
          return `${newValues.length} Subject${
            newValues.length > 1 ? "s" : ""
          }`;
        } else {
          return finalString;
        }
      }
      return placeholder;
    } else {
      return placeholder;
    }
  };

  return {
    value,
    isMobile,
    handleChange,
    renderText,
  };
};
